import { render } from "./CaseDocuments.vue?vue&type=template&id=5fec238c&ts=true"
import script from "./CaseDocuments.vue?vue&type=script&lang=ts"
export * from "./CaseDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__